import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBubble3"><Path d="M2.96071 16.428L2.15153 19.7578C1.84508 21.0189 2.96972 22.1631 4.23589 21.8785L7.70698 21.0981C7.75833 21.0866 7.82677 21.0904 7.90217 21.1243C9.1537 21.6872 10.5413 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5077 2.33418 14.9395 2.93323 16.2235C2.96998 16.3023 2.97374 16.3744 2.96071 16.428Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble3;
